module.exports = __webpack_public_path__ + "img/muted.2b93044a.svg";